import { useRef, useEffect } from 'react';

const BASE_STYLES = `
  :host {
    all: initial;
    display: block;
  }
  div {
    font-family: ui-sans-serif, system-ui, sans-serif;
    font-size: 0.875rem;
    line-height: 1.625;
    color: inherit;
    word-wrap: break-word;
    overflow-x: auto;
  }
  img {
    max-width: 100%;
    height: auto;
  }
  a {
    color: inherit;
    text-decoration: underline;
  }
  table {
    max-width: 100%;
    border-collapse: collapse;
  }
  p {
    margin: 0.5em 0;
  }
`;

export default function SafeEmailBody({ html, className = '' }) {
  const hostRef = useRef(null);

  useEffect(() => {
    const host = hostRef.current;
    if (!host || !html) return;

    const existingRoot = host.shadowRoot;
    if (existingRoot) {
      existingRoot.innerHTML = '';
    }
    const shadow = host.shadowRoot || host.attachShadow({ mode: 'open' });

    const safeHtml = html
      .replace(/<script[\s\S]*?<\/script>/gi, '')
      .replace(/on\w+\s*=\s*"[^"]*"/gi, '')
      .replace(/on\w+\s*=\s*'[^']*'/gi, '');

    const withSafeLinks = safeHtml.replace(
      /<a\s/gi,
      '<a target="_blank" rel="noopener noreferrer" '
    );

    shadow.innerHTML = `
      <style>${BASE_STYLES}</style>
      ${withSafeLinks}
    `;
  }, [html]);

  if (!html) return null;

  return (
    <div ref={hostRef} className={className} />
  );
}
